<template>
	<div style="padding: 10px 10px 10px 0;">
		<!-- 新增弹框 -->
		
		<el-dialog :title="title" :visible.sync="show" width="40%">
			<el-form ref="form" :model="form" label-width="96px">
				<el-row>
					<el-col :span="12">
						<el-form-item label="栋号">
							<el-select :disabled="title[0]=='查'" v-model="form.dongNumber" placeholder="栋号">
								<el-option label="A栋" value="A栋"></el-option>
								<el-option label="B栋" value="B栋"></el-option>
								<el-option label="C栋" value="C栋"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="层号">
							<el-select :disabled="title[0]=='查'" v-model="form.floorNumber" placeholder="层号">
								<el-option v-for="item in 21" :label="`${item}层`" :value="`${item}层`"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="巡检人">
							<el-select :disabled="title[0]=='查'" v-model="form.userId" placeholder="巡检人">
								<el-option v-for="item in users" :label="item.userName" :value="item.userId">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="计划有效时间" v-if="title=='新增'">
							<el-date-picker style="width: 100%;" v-model="form.time" type="daterange" range-separator="~"
								start-placeholder="开始日期" end-placeholder="结束日期" >
							</el-date-picker>
						</el-form-item>
						<el-form-item label="工作时间" v-if="title!='新增'">
							<el-date-picker style="width: 100%;"  :disabled="title[0]=='查'" v-model="form.standardTime" type="datetime"
								placeholder="选择日期时间">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12" v-if="title!='新增'">
						<el-form-item label="巡检区域">
							<el-input :disabled="title[0]=='查'" v-model="form.address" placeholder="巡检区域"></el-input>
						</el-form-item>
					</el-col>
					<div style="text-align: right;margin: 10px 0;" v-if="title=='新增'">
						<el-button type="primary" @click="addressList">添加</el-button>
					</div>
					<div v-for="(item,index) in form.addressList">
						<el-col :span="11">
							<el-form-item label="巡检区域">
								<el-input :disabled="title[0]=='查'" v-model="item.address" placeholder="巡检区域">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="11">
							<el-form-item label="打卡规定时间">
								<el-time-picker style="width: 100%;"  v-model="item.clockTime" placeholder="任意时间点"></el-time-picker>
							</el-form-item>
						</el-col>
						<el-col :span="2">
							<el-button type="danger" @click="movressList(index)">删除</el-button>
						</el-col>
					</div>
				</el-row>
				<!-- <el-form-item label="二维码">
					<img style="width:100px;height:100px;" @click="handleDownloadQrIMg(form.filePath)" :src="form.filePath" alt="">
					
				</el-form-item>
				<el-form-item>
					<div style="margin-top: -30px;">点击二维码或者右键另存为即可下载图片</div>
				</el-form-item> -->
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
				<el-button v-if="title[0]!='查'" type="primary" @click="ok">确 定</el-button>
			</span>
		</el-dialog>
		<!-- tab切换 -->
		<el-tabs v-model="type" @tab-click="handleClick">
			<!-- <el-tab-pane label="保洁检查计划表" name="保洁检查计划表">
			</el-tab-pane> -->
			<el-tab-pane label="保安检查计划表" name="保安检查计划表">
			</el-tab-pane>
		</el-tabs>
		<!-- 条件查询 -->
		<el-form :inline="true" :model="selectForm" class="demo-form-inline">
			<div class="flex sb">
				<div>
					<el-form-item label="栋号">
						<el-select v-model="selectForm.dongNumber" placeholder="栋号" style="width: 80px;">
							<el-option label="A栋" value="A栋"></el-option>
							<el-option label="B栋" value="B栋"></el-option>
							<el-option label="C栋" value="C栋"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="层号">
						<el-select v-model="selectForm.floorNumber" placeholder="层号" style="width: 80px;">
							<el-option v-for="item in 21" :label="`${item}层`" :value="`${item}层`"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="时间">
						<el-date-picker v-model="selectForm.time" type="daterange" range-separator="~"
							start-placeholder="开始日期" end-placeholder="结束日期" style="width: 280px;">
						</el-date-picker>
					</el-form-item>
					<el-form-item :label="type=='保洁检查计划表'?'负责人':'巡检人'">
						<el-input v-model="selectForm.userName" style="width: 100px;"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getAll()">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="handleClear">重置</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="addTemplate">下载导入模板</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="dc()">导出</el-button>
					</el-form-item>
					<el-form-item>
						<el-upload action="/api/admin/check/importSecurityCheck" name="file" :show-file-list="false"
							:headers="headers" :on-success="success">
							<el-button type="primary" style="margin-left: 10px;">导入</el-button>
						</el-upload>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="addRow">新增</el-button>
					</el-form-item>
				</div>
			</div>
		</el-form>
		<!-- 表格内容 -->
		<el-table :data="data" style="width: 100%" border>
			<el-table-column prop="dongNumber" label="栋号"></el-table-column>
			<el-table-column prop="floorNumber" label="层号"></el-table-column>
			<el-table-column prop="address" :label="type=='保洁检查计划表'?'责任区域':'巡检区域'"></el-table-column>
			<el-table-column prop="standardTime" label="时间">
				<template slot-scope="{row}">{{row.standardTime?setTime(row.standardTime):""}}</template>
			</el-table-column>
			<el-table-column prop="username" :label="type=='保洁检查计划表'?'责任人':'巡检人'"></el-table-column>
			<el-table-column prop="date" label="操作">
				<template slot-scope="{row}">
					<el-button type="text" @click="setRow(row,'1')">详情</el-button>
					<el-button type="text" @click="setRow(row,'2')">编辑</el-button>
					<el-button type="text" @click="movRow(row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination :page-sizes="[10, 20, 30, 50]" :page-size="selectForm.rows"
			layout="total, sizes, prev, pager, next, jumper" :total="count" @size-change="handleSizeChange"
			@current-change="handleCurrentChange">
		</el-pagination>
	</div>
</template>

<script>
	import publicExport from '../../assets/js/publicExport.js';
	export default {
		data() {
			return {
				users: [], //巡检人
				headers: { //请求头
					Authorization: localStorage.access_token,
				},
				title: "新增",
				count: 0,
				show: false,
				type: "保安检查计划表",
				selectForm: {
					page: 1,
					rows: 10,
					dongNumber: "", //楼号
					floorNumber: "", //层号
					time: "", //时间段
					startTime: "", //开始时间
					endTime: "", //结束时间
					userName: "",
					type: ""
				},
				oldSelect: {},
				oldForm: "",
				form: {
					userId: "", //巡检人id
					dongNumber: "", //楼号
					floorNumber: "", //层号
					startTime: "", //计划有效开始时间
					standardTime: "",
					endTime: "", //计划有效结束时间
					time: [], //时间数据
					type: "", //安保  保洁
					address: "", //修改时 巡检区域
					addressList: [{
						address: "", //巡检区域
						clockTime: "", //打卡规定时间
					}]
				},
				data: []
			}
		},
		methods: {
			
			//qrBase64是后台传回来的base64数据
			handleDownloadQrIMg(imgUrl) {
			      // 这里是获取到的图片base64编码,这里只是个例子哈，要自行编码图片替换这里才能测试看到效果
			      // const imgUrl = `data:image/png;base64,${qrBase64}`
			      // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
			      if (window.navigator.msSaveOrOpenBlob) {
			        const bstr = atob(imgUrl.split(',')[1])
			        let n = bstr.length
			        const u8arr = new Uint8Array(n)
			        while (n--) {
			          u8arr[n] = bstr.charCodeAt(n)
			        }
			        const blob = new Blob([u8arr])
			        window.navigator.msSaveOrOpenBlob(blob, 'chart-download' + '.' + 'png')
			      } else {
			        // 这里就按照chrome等新版浏览器来处理
			        const a = document.createElement('a')
			        a.href = imgUrl
			        a.setAttribute('download', 'chart-download'+ '.' + 'png')
			        a.click()
			      }
			},

			success(res) {
				if (res.code == 0) {
					this.getAll()
					this.$message.success("导入成功")
				} else {
					this.$message.error(res.message)
				}
			},
			addTemplate() { //下载导入模板
				this.$http.get(`/api/export/download`, {
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json;charset=utf-8",
					},
					responseType: "blob"
				}).then(res => {
					const link = document.createElement("a");
					let blob = new Blob([res.data], {
						type: "application/vnd.ms-excel"
					});
					link.style.display = "none";
					link.href = URL.createObjectURL(blob);
					link.download = `${this.type}模板.xls`;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				})
			},
			setRow(obj, type) {
				this.form = {
					...obj
				}
				console.log(this.form)
				this.$http.get(`/api/bdCheckWorkAttendance/generateWorkQRCode?address=${this.form.address}`).then(res=>{
					// console.log(res)
					 this.form.filePath='data:image/jpg;base64,'+res.data.data
					// this.form.img =res.data.data; 
					console.log(this.form.filePath)
				})
				this.show = true
				if (type == 1) {
					this.title = "查看"
					
				} else {
					this.title = "编辑"
				}
				
				
			},
			movRow(row) { //删除被点击
				this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete(`/api/check/delete`, {
						params: {
							id: row.id
						}
					}).then(res => {
						if (res.data.code == 0) {
							this.$message.success("删除成功")
							this.getAll();
						} else {
							this.$message.error("删除失败")
						}
					})
				}).catch(() => {
					this.$message.info('已取消删除');
				});
			},
			dc() {
				publicExport("/api/admin/export/uploadSecurityCheck", this.selectForm, this.type)
			},
			ok() { //新增或修改
				if (this.users.length == 0) {
					this.$message.warning("暂无巡检人")
					return
				}
				if (this.form.userId == "") {
					this.$message.warning("请选择巡检人")
					return
				}
				if(this.form.dongNumber==""){
					this.$message.error("请选择楼号")
					return
				}
				if(this.form.floorNumber==""){
					this.$message.error("请选择层号")
					return
				}
				if(this.form.time){
					if(this.form.time.length!=2){
						this.$message.error("请选择计划有效时间")
						return
					}
				}
				if(this.form.addressList){
					if(this.form.addressList[this.form.addressList.length - 1].address==""){
						this.$message.error("请填写巡检区域")
						return
					}
					if(!this.form.addressList[this.form.addressList.length - 1].clockTime){
						this.$message.error("请选择打卡规定时间")
						return
					}
				}
				let url = "/api/check/add"
				if (this.title == "编辑") {
					url = "/api/check/update"
				}
				if (this.form.time) {
					this.form.startTime = new Date(this.form.time[0]).getTime()
					this.form.endTime = new Date(this.form.time[1]).getTime()
				} else {
					this.form.startTime = ""
					this.form.endTime = ""
				}
				let addressList = []
				if (this.form.addressList) {
					this.form.addressList.forEach(item => {
						let time = ""
						if (item.clockTime != "") {
							time = new Date(item.clockTime).getTime()
						}
						addressList.push({
							address: item.address,
							clockTime: time
						})
					})
				}
				this.form.type = "安保"
				if (this.type == "保洁检查计划表") {
					this.form.type = "保洁"
				}
				let standardTime = "";
				if (this.form.standardTime) {
					standardTime = new Date(this.form.standardTime).getTime()
				}
				this.$http.post(url, {
					...this.form,
					addressList,
					standardTime
				}).then(res => {
					if (res.data.code == 0) {
						this.getAll()
						this.show = false
						this.$message.success(`${this.title}成功`)
					} else {
						this.$message.error(`${this.title}失败`)
					}
				})
			},
			addRow() {
				this.form = JSON.parse(JSON.stringify(this.oldForm))
				this.title = "新增"
				this.show = true;
			},
			getAll() {
				this.selectForm.startTime = ""
				this.selectForm.endTime = ""
				if (this.selectForm.time) {
					this.selectForm.startTime = new Date(this.selectForm.time[0]).getTime()
					this.selectForm.endTime = new Date(this.selectForm.time[1]).getTime()
				}
				this.selectForm.type = "安保"
				if (this.type == "保洁检查计划表") {
					this.selectForm.type = "保洁"
				}
				this.$http.post("/api/check/select", this.selectForm).then(res => {
					this.data = res.data.data.items
					this.count = res.data.data.totalNum
				})
			},
			handleClick() {
				this.getAll()
				this.getUser()
			},
			handleCurrentChange(val) {
				this.selectForm.page = val;
				this.getAll()
			},
			handleSizeChange(val) {
				this.selectForm.rows = val;
				this.getAll()
			},
			handleClear() {
				this.selectForm = JSON.parse(JSON.stringify(this.oldSelect))
				this.getAll()
			},
			movressList(index) { //删除一行巡检
				if(this.form.addressList.length ==1){
					this.$message.error("请至少保留一条数据")
					return
				}
				this.form.addressList.splice(index, 1)
			},
			addressList() { //添加一行巡检
				if(this.form.addressList[this.form.addressList.length - 1].address==""){
					this.$message.error("请填写完巡检区域再添加新的一行")
					return
				}
				if(!this.form.addressList[this.form.addressList.length - 1].clockTime){
					this.$message.error("请选择完打卡规定时间再添加新的一行")
					return
				}
				this.form.addressList.push({
					address: "", //巡检区域
					clockTime: "", //打卡规定时间
				})
			},
			getUser() { //获取巡检人
				this.form.userId = ""
				let roleId = 9 //保洁检查计划表
				if (this.type == "保安检查计划表") {
					roleId = 7
				}
				this.$http.get(`/api/check/selectXunJianUser`, {
					params: {
						roleId
					}
				}).then(res => {
					this.users = res.data.data
				})
			}
		},
		created() {
			this.oldForm = JSON.parse(JSON.stringify(this.form))
			this.oldSelect = JSON.parse(JSON.stringify(this.selectForm))
			this.getAll();
			this.getUser();
		}
	}
</script>

<style scoped="scoped">
</style>
